import { ICidCreateForm, ICidEditForm, CidModel } from './../../../models/cid.model';
import { BaseCrudStore } from '@monorepo/controlled/src/stores/base-crud.store';
import { FormError } from '@monorepo/tools/src/lib/models/form-error.model';
import { CidsApi } from '../../../apis/cids.api';
import { HttpError } from '../../../models/http-error.model';

export class CidsCrudStore extends BaseCrudStore<CidModel, ICidCreateForm, ICidEditForm, HttpError> {
	constructor() {
		super({
			apiLayer: {
				create: (body: ICidCreateForm) => CidsApi.create(this.getData().getCurrentCid()!, body),
				edit: CidsApi.edit,
				list: CidsApi.list,
				get: CidsApi.get,
				delete: CidsApi.delete,
			},
			model: CidModel,
			errorModel: HttpError,
		});
	}

	public getCreateFormData(): ICidCreateForm {
		return {
			target_cid: this.getData().getTargetCid()!,
			segments: this.getData()
				.getSegmentRows()
				.map(row => ({
					current_cid: row.getCurrentTargetCid()!,
					new_cid: row.getNewTargetCid()!,
				})),
		};
	}

	public getEditFormData(): ICidEditForm {
		return this.getCreateFormData();
	}

	public isValid(): boolean {
		this.formStore.reset();
		const currentCid = this.getData().getCurrentCid();
		const targetCid = this.getData().getTargetCid();
		const segmentRows = this.getData().getSegmentRows();

		if (!currentCid) {
			this.formStore.addError(new FormError('current_cid', 'Please select a Current CID'));
		}

		if (!targetCid) {
			this.formStore.addError(new FormError('target_cid', 'Please select a Target CID'));
		}

		segmentRows.forEach((row, index) => {
			if (!row.getNewTargetCid()) {
				this.formStore.addError(new FormError(`segments[${index}].new_cid`, 'Please select a New CID'));
			}
		});

		return this.formStore.getIsValid();
	}

	public clearData(): void {
		this.data = new CidModel();
	}
}
